export default class Service {
    constructor(form, service) {
        this.form = document.querySelector(form);
        this.service = service;
        this.step = 1;
        this.maxStep = document.querySelectorAll('[id^="step-"]').length;
        this.bonuses  = document.querySelectorAll('.bonus');
        this.errorBox = document.querySelector('.errorBox');
        this.validated = false;
        this.canbonus = false;
        this.deliverinfo = false;
        this.summary = {
            deliverystart: document.querySelector('.summary-deliverystart'),
            deliveryend: document.querySelector('.summary-deliveryend'),
            praemie: document.querySelector('.summary-praemie'),
            deliverinfo: document.querySelector('.deliverinfo'),
            bonus: document.querySelector('.canbonus'),
        };
        
        this.buttons = {
            next: document.querySelectorAll('.btn-next'),
            back: document.querySelectorAll('.btn-back'),
            validate: document.querySelector('.validateForm'),
            submit: this.form.querySelector('button[type="submit"]'),
        };
        
        this.init();
    };
    
    init() {
        this.form.addEventListener('submit', this.submit.bind(this));
        
        if(this.buttons.validate) {
            this.buttons.validate.addEventListener('click', this.validate.bind(this));
        }
        
        if(this.buttons.next) {
            this.buttons.next.forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();
                    this.next();
                });
            });
        }
        
        if(this.buttons.back) {
            this.buttons.back.forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();
                    if(this.canbonus) {
                        this.back();
                    } else {
                        this.back(true);
                    }
                });
            });
        }
        
        if(this.bonuses !== null) {
            this.bonuses.forEach(bonus => {
                bonus.addEventListener('click', event => {
                    event.preventDefault();
                    const element = event.currentTarget;
                    const details = element.querySelector('.bonus-details');
                    this.bonus.value = details.dataset.sap;
                    this.selectBonus(element);
                    this.next();
                });
            });
        }
    };
    
    submit(event) {
        OVS.app.helper.toggleButton(true);
        event.preventDefault();
        if(!this.validated) {
            OVS.app.helper.toggleButton(false);
            this.validate();
            return false;
        }
        
        let request = new Request('POST', this.form.getAttribute('action'));
        request.formData = this.form;
        request.call(function(data) {
            if(data.status == 'ok') {
                window.location.replace(data.redirect);
            } else {
                OVS.app.helper.toggleButton(false);
                if (this.errorBox) {
                    this.errorBox.classList.remove('d-none');
                }
            }
        }.bind(this));
    };
    
    validate(event) {
        if(event) {
            event.preventDefault();
        }
        
        let request = new Request('POST', this.form.getAttribute('action') + '/validate');
        request.formData = this.form;
        
        request.call(function(data) {
            this.afterValidate(data);
        }.bind(this));
    };
    
    afterValidate(data) {
        if(data.status == 'ok') {
            this.validated = true;
            this.buttons.submit.click();
        } else {
            this.clearErrors();
            this.error(data.error);
        }
    };
    
    next(skip = false) {
        this.updateSummary();
        document.querySelectorAll('.step-' + this.step).forEach(node => {
            node.classList.add('inactive');
        });
        
        this.step += 1;
        if(skip) this.step += 1;
        if(this.step > this.maxStep) this.step = this.maxStep;
        
        document.querySelectorAll('.step-' + this.step).forEach(node => {
            node.classList.remove('d-none');
        });
        OVS.app.helper.scrollTo('#step-' + this.step);
    };
    
    back(skip = false) {
        document.querySelectorAll('.step-' + this.step).forEach(node => {
            node.classList.add('d-none');
        });
        
        this.step -= 1;
        if(skip) this.step -= 1;
        if(this.step < 1) this.step = 1;
        
        document.querySelectorAll('.step-' + this.step).forEach(node => {
            node.classList.remove('inactive');
        });
        OVS.app.helper.scrollTo('#step-' + this.step);
    };
    
    updateSummary() {
        const activBonus = document.querySelector('.bonus.activedevice');
        
        if(this.summary.deliverystart) this.summary.deliverystart.innerHTML = this.deliverystart.value;
        if(this.summary.deliveryend) this.summary.deliveryend.innerHTML = this.deliveryend.value;
        if(activBonus && this.summary.praemie) this.summary.praemie.innerHTML = activBonus.querySelector('.title').innerHTML;
        
        if(this.summary.deliverinfo) {
            (this.deliverinfo) ? this.summary.deliverinfo.classList.remove('d-none') : this.summary.deliverinfo.classList.add('d-none');
        }
        
        if(this.summary.bonus) {
            (this.canbonus) ? this.summary.bonus.classList.remove('d-none') : this.summary.bonus.classList.add('d-none');
        }
    };
    
    selectBonus(element) {
        this.bonuses.forEach(node => {
            node.classList.remove('activedevice');
            node.querySelector('.s0').classList.remove('d-none');
            node.querySelector('.s1').classList.add('d-none');
        });
        
        element.classList.add('activedevice');
        element.querySelector('.s0').classList.add('d-none');
        element.querySelector('.s1').classList.remove('d-none');
    };
    
    error(errors) {
        errors.forEach(error => {
            let errorMessage = error.element ? error.element : error;
            let element = document.querySelector('.field-' + this.service + '-' + errorMessage + ' > div.text-danger');
            if(element) element.innerHTML = error.message;
        });
    };
    
    clearErrors() {
        let elements = document.querySelectorAll('.form-group > div.text-danger');
        if(elements) {
            elements.forEach(node => {
                node.innerHTML = '';
            });
        }
    };
}
